export default [
    {
        "id": "refunds",
        "html": require('./refunds/html').default,
        "css": require('./refunds/css').default,
        "cssTablet": require('./refunds/cssTablet').default,
        "cssMobile": require('./refunds/cssMobile').default,
        "scss": require('./refunds/scss').default,
        "scssTablet": require('./refunds/scssTablet').default,
        "scssMobile": require('./refunds/scssMobile').default,
        "js": require('./refunds/js').default,
        "minJs": require('./refunds/minJs').default
    }
]
